import React from "react";
import InfiniteScroll from "react-infinite-scroller";

import { Box, Card, CardContent, Grid, Typography } from "@material-ui/core";
import { useTheme, withStyles } from "@material-ui/core/styles";

import Spacer from "components/Spacer";

import OperatorCard from "./OperatorCard";
import Search from "./Search";
import Title from "./Title";
import Filter from "./Filter";
import Sort from "./Sort";
import { Operator } from "modules/customer/tools/product/operator";
import { useAppDispatch, useAppSelector } from "store";
import {
    clearCandidateOperator,
    selectCandidateOperator,
    selectFilteredOperators,
    setCandidateOperator
} from "modules/customer/tools/product/partnerFilters/partnerFiltersSlice";

const NUMBER_OF_VISIBLE_OPERATORS_INCREMENT = 15;

const StyledCard = withStyles(theme => ({
    root: {
        // @ts-ignore
        backgroundColor: theme.palette.quaternary.dark
    }
}))(Card);

const PartnerFascias: React.FC = () => {
    const dispatch = useAppDispatch();
    const theme = useTheme();

    const candidateOperator = useAppSelector(selectCandidateOperator);
    const [numberOfVisibleOperators, setNumberOfVisibleOperators] = React.useState<number>(0);
    const operators = useAppSelector(selectFilteredOperators);
    const operatorsLabel = `${operators.length} ${operators.length === 1 ? "operator" : "operators"}`;

    const visibleOperators = React.useMemo(() => {
        return operators.slice(0, numberOfVisibleOperators);
    }, [operators, numberOfVisibleOperators]);

    const handleSelect = (operator: Operator) => {
        dispatch(setCandidateOperator(operator));
    };

    const handleDeselect = () => {
        dispatch(clearCandidateOperator());
    };

    const handleLoadMore = React.useCallback(() => {
        setNumberOfVisibleOperators(previousNumberOfVisibleOperators => previousNumberOfVisibleOperators + NUMBER_OF_VISIBLE_OPERATORS_INCREMENT);
    }, [setNumberOfVisibleOperators]);

    React.useEffect(() => {
        setNumberOfVisibleOperators(NUMBER_OF_VISIBLE_OPERATORS_INCREMENT);
    }, [operators]);

    return (
        <InfiniteScroll
            initialLoad={false}
            loadMore={handleLoadMore}
            hasMore={numberOfVisibleOperators <= operators.length}
            useWindow={false}
        >
            <Box marginBottom={4}>
                <Box position="sticky" top={0} bgcolor={theme.palette.background.paper} zIndex={theme.zIndex.drawer}>
                    <Title />
                    <Search />
                    <Box display="flex" alignItems="center" paddingTop={2} paddingBottom={0.5}>
                        <Typography variant="body1" component="div">
                            &nbsp;&nbsp;{operatorsLabel}
                        </Typography>
                        <Spacer />
                        <Filter />
                        &nbsp;&nbsp;
                        <Sort />
                    </Box>
                </Box>
                {visibleOperators.length > 0 && (
                    <StyledCard elevation={0}>
                        <CardContent>
                            <Grid container spacing={2}>
                                {visibleOperators.map(operator =>
                                    <Grid key={operator.id} item xs={4}>
                                        <OperatorCard
                                            operator={operator}
                                            selected={candidateOperator?.id === operator.id}
                                            onSelect={handleSelect}
                                            onDeselect={handleDeselect}
                                        />
                                    </Grid>
                                )}
                            </Grid>
                        </CardContent>
                    </StyledCard>
                )}
            </Box>
        </InfiniteScroll>
    );
};

export default PartnerFascias;
